import React from 'react';
import { useBranding } from '../branding/BrandProvider';

interface FooterMinimalProps {
  className?: string;
  privacyUrl?: string;
  termsUrl?: string;
}

export function FooterMinimal({ className = '', privacyUrl, termsUrl }: FooterMinimalProps) {
  const { orgName } = useBranding();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`bg-gray-50 border-t border-gray-200 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p className="text-gray-600 text-sm">
            © {currentYear} {orgName}
          </p>
          
          {(privacyUrl || termsUrl) && (
            <div className="flex justify-center space-x-6 mt-4">
              {privacyUrl && (
                <a 
                  href={privacyUrl} 
                  className="text-gray-500 hover:text-gray-700 text-sm transition-colors"
                >
                  Privacy Policy
                </a>
              )}
              {termsUrl && (
                <a 
                  href={termsUrl} 
                  className="text-gray-500 hover:text-gray-700 text-sm transition-colors"
                >
                  Terms of Service
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}









